/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ows-abacus-contract
 * OpenAPI spec version: 1.0.0
 */

export type HealthStatus = (typeof HealthStatus)[keyof typeof HealthStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HealthStatus = {
  ok: "ok",
} as const;
